import React from "react";
import styled from "styled-components";
import {Button, DialogActions, Grid} from "@material-ui/core";

interface CourseViewFooterProps {
    onDismiss: () => void;
}

const GridContainer = styled(Grid)`
  padding-left: 16px;
  padding-right: 16px;
`;

const CourseViewFooter = (props: CourseViewFooterProps) => {
    const {onDismiss} = props;
    return (
        <DialogActions>
            <GridContainer
                container
                justify={'space-between'}
                alignItems={'center'}
                >
                < Grid item>
                    <Button
                        variant={'outlined'}
                        color={'secondary'}
                        onClick={onDismiss}
                    >
                        Close
                    </Button>
                </Grid>
            </GridContainer>
        </DialogActions>
    );
};

export default CourseViewFooter;